<template>
  <div>
    <!-- Feed Share Dialog -->
    <feed-share-dialog
      :itemData="itemData"
      :visible="feedShareDialogStatus"
      @close="feedShareDialogStatus = false"
    />

    <liked-user
      :listType="userListType"
      :showDialog.sync="feedUserDialogStatus"
      :itemData.sync="itemData"
      :postId.sync="itemData.Id"
    />

    <v-card flat color="greyColorLigthThree" class="px-5">
      <!-- User Information -->
      <v-card-title v-if="!academyPost">
        <v-layout align-center row wrap style="position: relative">
          <feed-post-header :itemData="itemData" />
          <v-spacer />
          <feed-card-more-menu v-if="!hideMoreMenu" :itemData="itemData" />
        </v-layout>
      </v-card-title>

      <!-- Content Detail -->
      <v-layout fill-height row wrap mx-4 mb-3>
        <v-flex xs12>
          <!-- Title -->
          <v-layout
            column
            wrap
            class="overflow-x-hidden pr-3 mt-0"
            style="line-height: 20px; word-wrap: break-word"
          >
            <h4
              style="font-size: 15px; overflow-y: hidden"
              @click="gotoPostdetail(itemData.Id)"
              :class="`hover-underline defaultColor--text font-weight-medium `"
              v-html="itemData.Content"
              v-linkified
            >
              <!-- {{
              
                ? itemData.Content.length > 150
                  ? itemData.Content.substring(0, 149) + "..."
                  : itemData.Content
                : ""
            }} -->
            </h4>
            <span
              v-if="academyPost"
              class="defaultColor--text font-weight-light"
              style="font-size: 12px !important"
              >{{ moment(itemData.CreatedAt).locale("tr").fromNow() }}</span
            >
          </v-layout>

          <!-- Links -->
          <v-layout
            row
            wrap
            class="overflow-x-hidden pr-3 mt-0"
            style="line-height: 20px; word-wrap: break-word"
          >
            <div v-for="(link, index) in itemData.Properties" :key="index">
              <h4
                style="font-size: 16px"
                @click="openLink(link.Value)"
                :class="`hover-underline light-blue--text font-weight-medium`"
                v-if="link.Key == 'link' && link.Value"
              >
                {{ $t("buttons.goToLink") }}
              </h4>
            </div>
          </v-layout>

          <!-- users -->
          <v-layout
            row
            wrap
            class="mt-2 pr-3 font-weight-bold "
            style="line-height: 18px; font-size: 15px"
          >
            <span
              :class="'mr-5 defaultColorLight--text underline-on-hover'"
              v-for="(User, index) in itemData.RelatedUsers"
              :key="index"
              style="cursor:pointer"
              @click="gotoProfile(User.Id)"
              >{{ User.FullName}}</span
            >
          </v-layout>

          <!-- tags -->
          <v-layout
            v-if="itemData.Tags.length > 0"
            row
            wrap
            class="mt-2 pr-3 defaultColor--text font-weight-light"
            style="line-height: 17px; font-size: 16px"
          >
            <span
              :class="'mr-3'"
              v-for="(tag, index) in itemData.Tags"
              :key="index"
              >{{ "#" + tag.TagName }}</span
            >
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- Media -->
      <div v-if="itemData.ParentPost == null">
        <feed-item-media :itemData="itemData" :academyPost="academyPost" />
      </div>

      <!-- SharePost -->
      <div v-else>
        <feed-share-item-card :itemData="itemData.ParentPost" />
      </div>

      <v-divider
        v-if="
          !isBatNewsPost &&
          itemData.Files.length <= 0 &&
          itemData.ParentPost == null
        "
        class="mx-3 mt-1"
      />

      <!-- Like, Comment and Share Button Actions-->
      <v-layout v-if="!isBatNewsPost" align-center row wrap mx-0 mt-2 mb-0 py-2>
        <v-btn
          text
          :disabled="likeFeedLoading"
          :loading="likeFeedLoading"
          color="defaultColorLightTwo"
          class="white--text font-weight-light px-0 ml-0"
          @click="likeStatus()"
        >
          <v-icon size="22" left>
            {{
              itemData.LikeStatus ? "mdi-cards-heart" : "mdi-cards-heart-outline"
            }}
          </v-icon>
          {{ itemData.LikeCount }}
        </v-btn>

        <v-btn
          text
          color="defaultColorLightTwo"
          class="white--text font-weight-light px-0"
          @click="getComments()"
        >
          <m-icon scale="1.1" class="mr-2" :name="'m-comment'" />
          {{ itemData.CommentCount }}
        </v-btn>

        <v-spacer />

        <v-btn
          v-if="
            ((itemData.ParentPost == null || itemData.IsShareable == true) &&
            !academyPost) && !postViewShow
          "
          text
          color="defaultColorLightTwo"
          class="white--text font-weight-light px-0"
          @click="feedShareDialogStatus = true"
        >
          <!-- <m-icon
            :scale="1.3"
            class="mr-0"
            :name="itemData.share ? 'm-share' : 'm-share-outline'"
          /> -->
          <icon-base viewBox='0 0 18 18' iconColor="transparent"><icon-share></icon-share></icon-base>
        </v-btn>

        <v-btn
          v-if="academyPost || postViewShow"
          text
          icon
          color="defaultColorLight"
          class="white--text font-weight-light px-0"
          @click="setUserListDialog('viewsUser', true)"
        >
          <v-icon size="22" left> mdi-eye </v-icon>
          {{ itemData.ViewCount }}
        </v-btn>

        <!-- <v-btn
          v-if="itemData.ParentPost == null || itemData.IsShareable == true"
          color="blue-grey"
          class="white--text text-capitalize"
          outlined
          rounded
          @click="feedShareDialogStatus = true"
        >
          <m-icon
            :scale="itemData.share ? 1.1 : 1.3"
            class="mr-2"
            :name="itemData.share ? 'm-share' : 'm-share-outline'"
          />
          {{ itemData.share ? "Paylaşıldı" : "Paylaş" }}
        </v-btn> -->
      </v-layout>

      <!-- Like and Comment Status -->
      <v-layout v-if="!isBatNewsPost" column wrap mx-4 mt-2 mb-0>
        <h4
          v-if="itemData.LikeCount > 0"
          @click="
            itemData.LikeCount != 0
              ? setUserListDialog('likedUsers', true)
              : null
          "
          style="font-size: 12px"
          class="hover-underline defaultColor--text font-weight-bold"
        >
          {{ itemData.LikeCount }} {{ $t("feed.userLike") }}
        </h4>
        <h4
          v-if="itemData.CommentCount > 0"
          @click="itemData.CommentCount != 0 ? getComments() : null"
          style="font-size: 12px"
          class="hover-underline greyColorDark--text mt-3 font-weight-medium"
        >
          {{ itemData.CommentCount }} {{ $t("feed.allComments") }}
        </h4>
      </v-layout>

      <!--My Last Commnet -->
      <v-layout
        column
        wrap
        mx-4
        my-0
        pb-2
        v-if="itemData.LastComment && !isBatNewsPost"
      >
        <v-layout
          ml-1
          mt-2
          mb-0
          row
          class="defaultColor--text pr-3"
          style="font-size: 15px"
        >
          <span class="font-weight-bold">
            {{ itemData.LastComment.User.FullName }}
          </span>
          <span class="ml-2">{{ itemData.LastComment.Text }}</span>
          <v-spacer />
          <v-btn
            color="defaultColorLightTwo"
            x-small
            icon
            class="text-capitalize pa-0"
            @click="likeStatusComment(itemData.LastComment)"
          >
            <v-icon
              size="20"
              :color="itemData.LastComment.LikeStatus ? 'defaultColorLightTwo' : ''"
              >{{
                itemData.LastComment.LikeStatus
                  ? "mdi-cards-heart"
                  : "mdi-cards-heart-outline"
              }}</v-icon
            >
          </v-btn>
        </v-layout>
      </v-layout>

      <!-- Comment Textfield -->
      <v-card-text v-if="!isBatNewsPost" class="mt-3">
        <v-layout row wrap align-center mb-1 pl-2>
          <v-text-field
            @keyup.enter="commentFeed"
            :disabled="commentProgress"
            v-model.trim="commentText"
            color="defaultColor"
            class="px-2 custom-placeholder-color"
            style="border-width: 1rem"
            multiline
            outlined
            append-icon="mdi-emoticon-happy"
            rounded
            hide-details
            full-width
            :placeholder="$t('add.comment')"
          >
            <template v-slot:append>
              <v-btn
                rounded
                small
                elevation="0"
                dark
                text
                color="defaultColorLight"
                @click="commentFeed"
                :disabled="!commentText"
                class="text-capitalize"
                style="margin-top: -3px"
              >
                {{ $t("buttons.send") }}
              </v-btn>
              <vue-emoji-picker @selectEmoji="(emoji) => {commentText = [...commentText, emoji.data]}" :marginTop="-8" />
            </template>
          </v-text-field>
        </v-layout>
      </v-card-text>

      <!-- Comment Dialog -->
      <feed-comments
        :showDialog.sync="commentDialogStatus"
        :itemData.sync="itemData"
      />
    </v-card>
    <v-divider v-if="!postDetail" class="mt-10" />
  </div>
</template>

<script>
import PostService from "../../services/PostService.js";
import FeedComments from "./FeedComments.vue";
import FeedPostHeader from "./FeedPostHeader.vue";
import FeedContentDetail from "./FeedContentDetail.vue";
import FeedShareDialog from "./FeedShareDialog.vue";
import FeedShareItemCard from "./FeedShareItemCard.vue";
import FeedCardMoreMenu from "./FeedCardMoreMenu.vue";
import FeedItemMedia from "./FeedItemMedia.vue";
import LikedUser from "../Users/LikedUser.vue";
import IconBase from "../Icons/IconBase.vue";
import IconShare from "../Icons/IconShare.vue";
import VueEmojiPicker from "../Emoji/VueEmojiPicker.vue";

//TODO: Post Paylaşım, Yorumlar, Çoklu Foto ve video gösterimi ve Daha Fazla seçenekleri kaldı.

export default {
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    hideMoreMenu: {
      type: Boolean,
      default: false,
    },
    newsBat: {
      type: Boolean,
      default: false,
    },
    academyPost: {
      type: Boolean,
      default: false,
    },
    postDetail: {
      type: Boolean,
      default: false,
    },
    postViewShow: {
      type:Boolean,
      default:false,
    }
  },

  data() {
    return {
      commentDialogStatus: false,
      commentProgress: false,
      commentText: "",

      likeFeedLoading: false,

      feedShareDialogStatus: false,

      feedUserDialogStatus: false,

      userListType: "likedUsers",
    };
  },

  components: {
    FeedComments,
    FeedPostHeader,
    FeedContentDetail,
    FeedShareDialog,
    FeedShareItemCard,
    FeedCardMoreMenu,
    FeedItemMedia,
    LikedUser,
    IconBase,
    IconShare,
    VueEmojiPicker
  },

  mounted() {},

  methods: {
    replaceToLink(text) {
      const exp = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      console.log('link :' , text.replace(exp, ""))
      return text.replace(exp, "");
    },

    getComments() {
      this.commentDialogStatus = true;
    },

    commentFeed(event, ParentId = null) {
      if (!this.commentProgress) {
        this.commentProgress = true;
        const body = {
          Text: this.commentText,
          ParentId,
        };
        this.commentProgress = false;
        PostService.commentFeed(this.itemData.Id, body)
          .then((res) => {
            this.itemData.LastComment = res.data;
            this.itemData.CommentCount++;
            showSuccess(this.$t("comment.send.success"));
          })
          .catch((err) => {
            console.log("err :", err);
            showError(err);
          })
          .then(() => {
            this.commentProgress = false;
            this.commentText = "";
          });
      }
    },

    likeStatus() {
      if (this.itemData.LikeStatus) {
        // false yapma servisi
        this.unLikeFeed();
      } else {
        // true yapma servisi
        this.likeFeed();
      }
    },

    unLikeFeed() {
      this.likeFeedLoading = true;
      PostService.unLikePost(this.itemData.Id)
        .then((res) => {
          this.itemData.LikeStatus = false;
          this.itemData.LikeCount--;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.likeFeedLoading = false;
        });
    },

    likeFeed() {
      this.likeFeedLoading = true;
      PostService.likePost(this.itemData.Id)
        .then((res) => {
          this.itemData.LikeStatus = true;
          this.itemData.LikeCount++;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.likeFeedLoading = false;
        });
    },

    likeStatusComment(item) {
      if (item.LikeStatus) {
        // false yapma servisi
        this.unLikeFeedComment(item);
      } else {
        // true yapma servisi
        this.likeFeedComment(item);
      }
    },

    unLikeFeedComment(item) {
      console.log("unLike:" + item.Id);
      item.LikeStatus = false;
      item.LikeCount--;
      PostService.unLikeComment(item.Id)
        .then((res) => {})
        .catch((err) => {
          item.LikeStatus = true;
          item.LikeCount++;
          showError(err);
        })
        .then(() => {
          //this.likeFeedLoading = false;
        });
    },

    likeFeedComment(item) {
      item.LikeStatus = true;
      item.LikeCount++;
      PostService.likeComment(item.Id)
        .then((res) => {})
        .catch((err) => {
          item.LikeStatus = false;
          item.LikeCount--;
          showError(err);
        })
        .then(() => {
          //this.likeFeedLoading = false;
        });
    },

    share(item) {
      //Share Process
    },

    likeComment() {
      toggleLoading();
      feedService
        .likeComment(this.itemData.feed.id, this.itemData.feed.lastComment.id)
        .then((res) => {
          this.itemData.feed.lastComment.likeStatus = true;
          this.itemData.feed.lastComment.likeCount++;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          toggleLoading();
        });
    },

    unLikeComment() {
      toggleLoading();
      feedService
        .deleteCommentLike(
          this.itemData.feed.id,
          this.itemData.feed.lastComment.id
        )
        .then((res) => {
          this.itemData.feed.lastComment.likeStatus = false;
          this.itemData.feed.lastComment.likeCount--;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          toggleLoading();
        });
    },

    searchTags() {},

    setUserListDialog(type, status) {
      this.userListType = type;
      this.feedUserDialogStatus = status;
    },
  },

  computed: {
    getLikerUnderine() {
      if (this.itemData.LikeCount !== 0) {
        return "hover-underline";
      }
    },

    isBatNewsPost() {
      if (this.newsBat) {
        return true;
      } else if (
        this.itemData.Key == "kurumsal_haberler" &&
        this.itemData.Type == "corporate"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
.feed-card--rounded {
  border-radius: 15px;
}

.hover-underline:hover {
  text-decoration: underline;
  cursor: pointer;
}

.comment-box {
  border-radius: 10px;
  border: 1px solid #afafaf !important;
}

.comment-box .v-input__slot {
  border: none !important;
  border-radius: 10px;
}
</style>
